import { Box, Chip, Stack, Typography, alpha, useTheme } from "@mui/material";
import * as labels from "./constants";
import { SectorDisplay, PlantDisplay } from "./shared";

interface sectorsAndPlantsReadonlyProps {
	sectors: SectorDisplay[];
	plants: PlantDisplay[];
}

export function SectorsAndPlantsReadonly({ sectors, plants }: sectorsAndPlantsReadonlyProps): React.JSX.Element {
	const theme = useTheme();

	const chipSx = {
		height: 22,
		borderRadius: 1,
		backgroundColor: alpha(theme.palette.primary.main, 0.08),
		"& .MuiChip-label": { px: 0.75, fontWeight: 400, fontSize: "0.78rem" },
	};

	const plantsBySector = sectors
		.map((sector) => ({
			sector,
			plants: plants.filter((p) => p.sectorId === sector.id),
		}))
		.filter(({ plants: sp }) => sp.length > 0);

	if (plantsBySector.length > 0) {
		return (
			<Stack spacing={1} sx={{ pl: 1.5 }}>
				{plantsBySector.map(({ sector, plants: sectorPlants }) => (
					<Box key={sector.id}>
					<Typography sx={{ fontWeight: 700, fontSize: "0.82rem", color: "text.secondary" }}>
						{sector.name}
					</Typography>
						<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, ml: 1.5, mt: 0.25 }}>
							{sectorPlants.map((p) => (
								<Chip key={`${sector.id}-${p.id}`} label={p.name} size="small" sx={chipSx} />
							))}
						</Box>
					</Box>
				))}
			</Stack>
		);
	}

	if (sectors.length > 0) {
		return (
			<Stack spacing={1} sx={{ pl: 1.5 }}>
				<Box>
				<Typography sx={{ fontWeight: 700, fontSize: "0.82rem", color: "text.secondary", mb: 0.25 }}>
					{labels.Sectors}
				</Typography>
					<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, ml: 1.5 }}>
						{sectors.map((s) => (
							<Chip key={s.id} label={s.name} size="small" sx={chipSx} />
						))}
					</Box>
				</Box>
			</Stack>
		);
	}

	return <></>;
}
